import { MonitoringTask } from '@/types/apiModels'
import { queryKeys } from '../../../../hooks/data/queryKeys'
import { queryClient } from '../../../../queryClient'
import { type ApiV2QueryType } from '../../../ruutsApi/types'
import getMonitoringTasks from './getMonitoringTasks'

// Imperative, cache-aware task lookup used from an event callback (SOC dialog columns),
// not at render time — hence queryClient.fetchQuery rather than a useQuery hook (playbook §2.5).
export const loadMonitoringTasks = (query: ApiV2QueryType<MonitoringTask>) =>
  queryClient.fetchQuery({
    queryKey: queryKeys.monitoringTasks(query),
    queryFn: ({ signal }) => getMonitoringTasks({ query, signal }),
  })
